import { render, staticRenderFns } from "./ClientNameFields.vue?vue&type=template&id=63a63517"
import script from "./ClientNameFields.vue?vue&type=script&lang=js"
export * from "./ClientNameFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports